import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common'; // Import CommonModule

import { ReactiveFormsModule } from '@angular/forms';

import { BlockTextComponent } from '../../../common/block-text/block-text.component';
import {
  OnlyCtaInitModel,
  OnlyCtaInitVariables,
  OnlyCtaModel,
  OnlyCtaVariables,
} from '../../../../../models/email-template/only-cta.interface';
import { BaseComponent } from '../../../common/BaseComponent';
import { NotificationComponent } from '../../../common/notification/notification.component';
import { PinComponent } from '../../../common/pin/pin.component';
import { Helper } from '../../../../../utils/helper';

@Component({
    selector: 'app-only-cta',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        BlockTextComponent,
        NotificationComponent,
        PinComponent,
    ],
    templateUrl: './only-cta.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './only-cta.component.scss'
})
export class OnlyCtaComponent extends BaseComponent implements OnInit {
  @Input() block: OnlyCtaModel = new OnlyCtaInitModel();
  @Input() isPreview = false;
  @Output() blockData = new EventEmitter<any>(); // Event emitter to send data to the parent
  @Output() removeBlockEvent = new EventEmitter<string | null>(); // New EventEmitter for remove

  ngOnInit() {
    if (Helper.isEmpty(this.block.variables!)) {
      this.block.variables = new OnlyCtaInitVariables()
    }
  }

  //placeholders:
  onlyCtaLinkPlaceholder: string = 'Enter CTA link';
  onlyCtaTextPlaceholder: string = 'Enter CTA text';

  removeBlock(): void {
    this.removeBlockEvent.emit(this.block.blockId); // Emit the ID to parent
  }

  onChange(value: any, fieldName: keyof OnlyCtaVariables) {
    if (this.block.variables) {
      this.block.variables[fieldName] = value;
      this.blockData.emit(this.block);
    }
  }

  onContainerClick(event: MouseEvent) {
    // Forward the click event to the child app-pin component
    this.pinComponent.onContainerClick(event);
  }

  handleOnSegmentChange(segment: string, blockName: string) {
    if (this.block.variables) {
      this.block.variables[blockName as keyof OnlyCtaVariables] = segment;
      this.blockData.emit(this.block);
    }
    return;
  }
}
